import { Link } from "react-router-dom";
import "./css/top_rated_schools.css";

const TopRatedSchool = ({
  rating,
  name,
  district,
  banner,
  url,
  school_brief_description,
  index,
  scrollPosition
}) => {
  return (
    <div
      className="top_rated_school"
      onMouseOver={(e) => {
        e.target?.querySelector(".banner")?.classList.add("toggle_on_hover");
        e.target
          ?.querySelector(".shown_on_hover")
          ?.classList.remove("initially_hidden");
        e.target
          ?.querySelector(".rating")
          ?.classList.add("displayed_none");
      }}
      onMouseLeave={(e) => {
        e.target?.querySelector(".banner")?.classList.remove("toggle_on_hover");
        e.target
          ?.querySelector(".shown_on_hover")
          ?.classList.add("initially_hidden");
          e.target
          ?.querySelector(".rating")
          ?.classList.remove("displayed_none");
      }}
      
      style={{
        transform: `translateX(${scrollPosition}px)`,
        transition: "transform 0.3s ease-in-out",
      }}
    >
      <p
        className="banner"
        onMouseOver={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.add("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.add("initially_hidden");
          e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.add("displayed_none");
        }}
        onMouseLeave={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.remove("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.remove("initially_hidden");
            e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.remove("displayed_none");
        }}
      >
        <span
          className="rating"
          onMouseOver={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.add("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.remove("initially_hidden");
            e.target.classList.add("displayed_none");
          }}
          onMouseLeave={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.remove("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.add("initially_hidden");
            e.target.classList.remove("displayed_none");
          }}
        >
          {rating}
        </span>
        <img
          src={banner}
          alt={`top rated school${banner}`}
          onMouseOver={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.add("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.remove("initially_hidden");
            e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.add("displayed_none");
          }}
          onMouseLeave={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.remove("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.add("initially_hidden");
              e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.remove("displayed_none");
          }}
        />
      </p>
      <p
        className="name"
        onMouseOver={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.add("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.remove("initially_hidden");
          e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.add("displayed_none");
        }}
        onMouseLeave={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.remove("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.add("initially_hidden");
            e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.remove("displayed_none");
        }}
      >
        {name}
      </p>
      <p
        className="district"
        onMouseOver={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.add("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.remove("initially_hidden");
          e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.add("displayed_none");
        }}
        onMouseLeave={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.remove("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.add("initially_hidden");
            e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.remove("displayed_none");
        }}
      >
        {district}
      </p>
      <div
        className="shown_on_hover initially_hidden"
        onMouseOver={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.add("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.remove("initially_hidden");
          e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.add("displayed_none");
        }}
        onMouseLeave={(e) => {
          e.target?.parentElement
            ?.querySelector(".banner")
            ?.classList.remove("toggle_on_hover");
          e.target?.parentElement
            ?.querySelector(".shown_on_hover")
            ?.classList.add("initially_hidden");
            e.target?.parentElement
            ?.querySelector(".rating")
            ?.classList.remove("displayed_none");
        }}
      >
        <p
          className="school_brief_description"
          onMouseOver={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.add("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.remove("initially_hidden");
            e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.add("displayed_none");
          }}
          onMouseLeave={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.remove("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.add("initially_hidden");
              e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.remove("displayed_none");
          }}
        >
          {school_brief_description.length > 200
            ? `${school_brief_description.slice(0, 200)}...`
            : school_brief_description}
        </p>
        <p className="rating_with_stars"
          onMouseOver={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.add("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.remove("initially_hidden");
            e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.add("displayed_none");
          }}
          onMouseLeave={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.remove("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.add("initially_hidden");
              e.target?.parentElement?.parentElement
              ?.querySelector(".rating")
              ?.classList.remove("displayed_none");
          }}
        >
          {Math.floor(rating) <= 5 && Math.floor(rating) >= 0 ? ([...Array(Math.floor(rating)).keys()]
            .map((i) => i + 1)
            .map(() => (
              <span className="full_stars"></span>
            ))) : (
              <span></span>
            )}
          {Math.floor(rating) <= 5 && Math.floor(rating) >= 0 ? ([...Array(5 - Math.floor(rating)).keys()]
            .map((i) => i + 1)
            .map(() => (
              <span className="hollow_stars"></span>
            ))) : (
              <span></span>
            )}
          <span className="school_rating">{rating}</span>
        </p>
        <Link
          to={url}
          target="_blank"
          onMouseOver={(e) => {
            e.target?.parentElement?.parentElement
              ?.querySelector(".banner")
              ?.classList.add("toggle_on_hover");
            e.target?.parentElement?.parentElement
              ?.querySelector(".shown_on_hover")
              ?.classList.remove("initially_hidden");
          }}
          // onMouseLeave={(e) => {
          //   e.target?.parentElement?.parentElement
          //     ?.querySelector(".banner")
          //     ?.classList.remove("toggle_on_hover");
          // }}
        >
          More info
        </Link>
      </div>
    </div>
  );
};

export default TopRatedSchool;
